import { List, ListItem } from "@dealer-center/core-components";
import { AccountListItem } from "./AccountListItem";
import styled from "styled-components";
import { useGetAccountNames } from "@dealer-center/ddc-api-account-fetch";
import type { AccountNames } from "@dealer-center/ddc-api-account-interface";

const StyledListContainerWrapper = styled.div`
  .list-container__header-title {
    height: 36px;
    padding-bottom: 4px;
    margin: 0;
    font-size: 16px;
  }
`;
export function AccountList({
  accounts,
  onDelete,
  title
}: {
  accounts?: readonly string[];
  onDelete?: (account: string) => void;
  title: string;
}) {
  const { data: accountNames, isLoading: loading } =
    useGetAccountNames(accounts);

  const htmlIdSafeTitle = title.replace(/\s/g, "-");
  const accountsToUse: AccountNames[] | undefined = accountNames?.length
    ? accountNames
    : accounts?.map(account => ({ accountId: account }));
  return (
    <StyledListContainerWrapper>
      <h2>{title}</h2>
      {accountsToUse && accountsToUse.length > 0 && (
        <List>
          {accountsToUse.map(account => {
            return (
              <ListItem
                key={`${htmlIdSafeTitle}-AccountList-item-${account.accountId}`}
                sx={{
                  border: 0,
                  margin: 0,
                  padding: 0
                }}
              >
                <AccountListItem
                  account={account}
                  isLoadingAccountName={loading}
                  testId={`${htmlIdSafeTitle}-AccountList-item-${account.accountId}`}
                  onDelete={onDelete}
                />
              </ListItem>
            );
          })}
        </List>
      )}
    </StyledListContainerWrapper>
  );
}
